import BlankLayout from './blankLayout.js';

export default BlankLayout;
